// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"d7b4c7f1","453":"fa7fb07f","699":"be4c53e0"}[chunkId] + ".chunk.js";
};